import { FAQS } from "./faqs";

// Plain <details> = crawlable, accessible, no JS needed.
export default function Faq() {
  return (
    <section id="faq" className="scroll-mt-20 bg-[#F3F7FB] px-5 py-24 sm:px-8 lg:py-28">
      <div className="mx-auto max-w-4xl">
        <h2 className="font-heading text-3xl font-extrabold tracking-tight text-[#0E1726] sm:text-4xl">
          Borehole drilling and solar questions, answered
        </h2>
        <div className="mt-10 divide-y divide-slate-300 border-y border-slate-300">
          {FAQS.map((f) => (
            <details key={f.q} className="group py-5">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-heading text-lg font-bold text-[#0E1726]">
                {f.q}
                <span className="text-[#1F7BE0] transition-transform group-open:rotate-45">+</span>
              </summary>
              <p className="mt-3 leading-relaxed text-slate-600">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}